<template>
  <div class="pt-0 pr-1 pl-1">
    <div class="no-gutters mt-1 mb-2 ml-3 mr-3">
      <div class="row">
        <div class="col-6">
          <div class="parameter-box">
            <h5 v-b-popover.hover.bottom="latitude + ' ' + longitude">{{ position }}</h5>
            <div class="parameter-name">Current position</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="speed_over_ground !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 20)" title="Show speed over ground in chart and map">{{ showDigits(speed_over_ground, 1) }}</a> <small>kn</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Speed over ground</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="course_over_ground !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 21)" title="Show course over ground in chart and map">{{ showDigits(course_over_ground, 1) }}</a><small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrow(course_over_ground) }" />
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Course over ground</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 d-none d-sm-block">
          <span class="ml-2 dashboard-group-header">Scientific data:</span>
        </div>
        <div class="col-9 d-none d-sm-block">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
        <div class="col-6 d-block d-sm-none">
          <span class="ml-2 dashboard-group-header">Scientific data:</span>
        </div>
        <div class="col-6 d-block d-sm-none">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="parameter-box">
            <div class="parameter-name">By <b-img img src="/beluga-web/static/logos/iow.jpg" alt="Logo IOW" style="height: 40px"></b-img></div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="water_temperature !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 1)" title="Show water temperature in chart and map">{{ showDigits(water_temperature, 1) }}</a> <small>°C</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Water temperature</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="salinity !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 2)" title="Show salinity in chart and map">{{ showDigits(salinity, 1) }}</a> <small>PSU</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Salinity</div>
          </div>
        </div>
        <div class="col-3">
          <div class="parameter-box">
            <h4 v-if="chlorophyll !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 8)" title="Show oxygen in chart and map">{{ showDigits(chlorophyll, 1) }}</a> <small>μg/L</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Chlorophyll</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/mixins/helpers'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'ShipIowDashboardWidget',
  mixins: [
    Helpers
  ],
  props: ['platformId'],
  methods: {
    ...mapMutations(['select_parameter']),
    rotateArrow: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    },
    selectParameter: function (entityId, parameterId) {
      this.select_parameter([this.platformId, entityId, parameterId])
    }
  },
  computed: {
    ...mapState(['platforms']),
    ...mapGetters(['currentUpdate', 'lastUpdate', 'parameter']),
    recentUpdate () {
      return (entityId, parameterId) => {
        const update = this.currentUpdate(this.platformId, entityId, parameterId)
        return (update.length !== 0) ? Number(update[1]) : null
      }
    },
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      // Latitude will always be visible
      console.log('get latitude value')
      const update = this.currentUpdate(this.platformId, 1, 1)
      console.log(update)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      // Longitude will always be visible
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    water_temperature () {
      return this.recentUpdate(102, 1)
    },
    salinity () {
      return this.recentUpdate(102, 2)
    },
    chlorophyll () {
      return this.recentUpdate(102, 8)
    },
    heading () {
      return this.recentUpdate(1, 3)
    },
    speed_over_ground () {
      return this.recentUpdate(1, 20)
    },
    course_over_ground () {
      return this.recentUpdate(1, 21)
    }
  }
}
</script>

<style scoped lang="scss">

.parameter-box {
  padding: 10px 10px 5px 10px;
}
.parameter-box h4 {
  margin-bottom: 2px;
}
.parameter-box h5 {
  margin-bottom: 2px;
}
.parameter-name {
  font-size: 11px;
  color: #6c757d;
}
.parameter-link {
  color: #212529;
  text-decoration: none;
}
.state-box {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 2px 5px 2px;
}
.state-ok {
  background-color: #82E0AA;
  color: #186A3B;
}
.state-danger {
  background-color: #F1948A;
  color: #78281F;
}
.no-gutters {
  margin-right: 10px;
  margin-left: 10px;
  .col,
  [class*="col-"] {
    padding-right: 2px;
    padding-left: 2px;
  }
}
.dashboard-group-header {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  font-weight: bold;
}
.dashboard-group-header-hr {
  margin-block-end: 0;
}

</style>
